module.exports = __webpack_public_path__ + "227f4dcfb0b97d24515b9715d80a8249.gif";